import { useState, useEffect } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Cardsimple from '../../cards/Cardsimple';
import Topnavbar from '../../sections/Topnavbar';
import Leftnavbar from '../../sections/Leftnavbar';
import Footerbar from '../../sections/Footerbar';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const ChatboxIA = () => {
  const [pregunta, setPregunta] = useState('');
  const [respuestaIA, setRespuestaIA] = useState('');
  const [textoVisible, setTextoVisible] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const enviarPregunta = async () => {
    const consulta = pregunta.trim();
    if (!consulta) return;

    setLoading(true);
    setError('');
    setRespuestaIA('');
    setTextoVisible('');

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('Sesión expirada o sin token.');
        setLoading(false);
        return;
      }

      const url = `${process.env.REACT_APP_URL_API}chatbox-ia/responder`;
      const res = await axios.post(
        url,
        { pregunta: consulta },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (res.data?.respuestaIA) {
        setRespuestaIA(res.data.respuestaIA);
      } else {
        setError('No se recibió respuesta válida de la IA.');
      }
    } catch (err) {
      setError('Ocurrió un problema al consultar la IA.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!respuestaIA) return;

    setTextoVisible('');
    const regex = /(\S+)(\s*)/g;
    const tokens = [];
    let m;
    while ((m = regex.exec(respuestaIA)) !== null) {
      tokens.push((m[1] || '') + (m[2] || ''));
    }

    if (tokens.length === 0) {
      setTextoVisible(respuestaIA);
      return;
    }

    let i = 0;
    const velocidad = 20;
    const timer = setInterval(() => {
      setTextoVisible((prev) => prev + tokens[i]);
      i++;
      if (i >= tokens.length) clearInterval(timer);
    }, velocidad);

    return () => clearInterval(timer);
  }, [respuestaIA]);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Chat IA Preventivo</title>
        </Helmet>
      </HelmetProvider>
      <Leftnavbar />
      <Topnavbar />
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-10">
                <h1 className="m-0">
                  Chat <span style={{ color: '#444', fontWeight: 'bold' }}>IA Preventivo</span>
                </h1>
              </div>
              <div className="col-lg-2">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item"><a href="#">Home</a></li>
                  <li className="breadcrumb-item active">Chat IA</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 text-sm">
                <Cardsimple
                  condensed={false}
                  header={
                    <div className="row">
                      <div className="col-md-9">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Escribe tu consulta técnica sobre programación preventiva..."
                          value={pregunta}
                          onChange={(e) => setPregunta(e.target.value)}
                          disabled={loading}
                        />
                      </div>
                      <div className="col-md-3">
                        <button
                          className="btn btn-primary w-100"
                          onClick={enviarPregunta}
                          disabled={loading || !pregunta.trim()}
                        >
                          Consultar IA
                        </button>
                      </div>
                    </div>
                  }
                >
                  {loading && (
                    <div className="text-center py-4">
                      <div className="spinner-grow spinner-grow-sm" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <div className="text-center">Pensando... </div>
                    </div>
                  )}
                  {error && <div className="alert alert-warning">{error}</div>}

                  {!loading && !error && textoVisible !== '' && (
                    <div className="markdown-body">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {textoVisible}
                      </ReactMarkdown>
                      <hr />
                      <div className="ai-header card-footer">
                        <small className="ai-note">
                          <b>💬 Versión Beta:</b> Respuesta generada automáticamente con base en datos programados. Sujeta a revisión técnica.
                        </small>
                      </div>
                    </div>
                  )}
                </Cardsimple>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footerbar />
    </>
  );
};

export default ChatboxIA;